import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowLineLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 12H6.75M13.5 18.75 6.75 12l6.75-6.75M3.75 20.25V3.75"
    />
  </svg>
);
export default SvgArrowLineLeft;
